import { render, staticRenderFns } from "./pagenoutfound.vue?vue&type=template&id=264cf253&scoped=true&"
import script from "./pagenoutfound.vue?vue&type=script&lang=js&"
export * from "./pagenoutfound.vue?vue&type=script&lang=js&"
import style0 from "./pagenoutfound.vue?vue&type=style&index=0&id=264cf253&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264cf253",
  null
  
)

export default component.exports